module.exports = __webpack_public_path__ + "assets/378a2872311e2b1d6e5e6d66c69ee700.png";